import { groupArrayByKeys } from '@campus/utils';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SchoolBillingAddressInterface } from '../../+models';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './school-billing-address.reducer';

export const selectSchoolBillingAddressState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectSchoolBillingAddressState, (state: State) => state.error);

export const getLoaded = createSelector(selectSchoolBillingAddressState, (state: State) => state.loaded);

export const getAll = createSelector(selectSchoolBillingAddressState, selectAll);

export const getCount = createSelector(selectSchoolBillingAddressState, selectTotal);

export const getIds = createSelector(selectSchoolBillingAddressState, selectIds);

export const getAllEntities = createSelector(selectSchoolBillingAddressState, selectEntities);
export const getAllBySchoolId = createSelector(
  getAll,
  (schoolBillingAddresses: SchoolBillingAddressInterface[]) =>
    groupArrayByKeys(schoolBillingAddresses, ['schoolId']) as Dictionary<SchoolBillingAddressInterface[]>
);
/**
 * returns array of objects in the order of the given ids
 * @example
 * schoolBillingAddress$: SchoolBillingAddressInterface[] = this.store.pipe(
    select(SchoolBillingAddressQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectSchoolBillingAddressState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * schoolBillingAddress$: SchoolBillingAddressInterface = this.store.pipe(
    select(SchoolBillingAddressQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectSchoolBillingAddressState,
  (state: State, props: { id: number }) => state.entities[props.id]
);
